import _get from 'lodash/get'
import _parseInt from 'lodash/parseInt'
import { log as logError } from 'log/error'
import { post as apiPost, TYPE_VA_SERVICE } from 'api-client'
import strictUriEncode from 'strict-uri-encode'

export const VA_DEFAULT_PLAYER_TYPE = 'vjs4-webapp'
export const VA_SHARE_PLAYER_TYPE = 'vjs4-webapp-share'

/**
 * The first call to video analytics which creates a records
 * this media view
 */
export async function add (options) {
  const { id, data, auth } = options
  try {
    const res = await apiPost(`analytics/st/add/${strictUriEncode(id)}`, data, { auth }, TYPE_VA_SERVICE)
    return handleAddResponse(res, data)
  } catch (e) {
    return handleAddResponse({}, data)
  }
}

export function handleAddResponse (res, reqData) {
  const data = _get(res, 'body', {})
  const status = _parseInt(_get(data, 'status', -1))
  if (status !== 1 && status !== 2) {
    logError(
      `The video analytics response was not valid. Request: "${JSON.stringify(
        reqData,
      )}" Response: "${JSON.stringify(data)}"`,
    )
  }
  return data
}

/**
 * The first call to video analytics is an add call
 * then all other calls are update calls using data
 * from the add response
 */
export async function update (options) {
  const {
    stId, stToken, data, auth,
  } = options
  try {
    const res = await apiPost(
      `analytics/st/upd/${strictUriEncode(stId)}/${strictUriEncode(stToken)}`,
      data,
      { auth },
      TYPE_VA_SERVICE,
    )
    return handleUpdateResponse(res, stId, stToken, data)
  } catch (e) {
    return handleUpdateResponse({}, stId, stToken, data, true)
  }
}

export function handleUpdateResponse (res) {
  return _get(res, 'body', {})
}
